module.exports = __webpack_public_path__ + "img/mp_011.71bc2977.jpg";